// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".brand-logo[data-v-0ed5c907]{display:flex;flex-shrink:0}.brand-logo__img[data-v-0ed5c907]{height:2rem;max-height:2rem;-o-object-fit:contain;object-fit:contain;width:auto}@media (min-width:1024px){.brand-logo__img[data-v-0ed5c907]{height:2.5rem;max-height:2.5rem}}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
